import Vue from 'vue';

export function t(value: string, args?: Record<string, any>): string {
  // translates and removes dashes in case of failure to translate
  return Vue.prototype.$t(value, args);
}
export function tc(key: string, choice?: number, args?: Record<string, any>): string {
  // translates and removes dashes in case of failure to translate
  return Vue.prototype.$tc(key, choice, args);
}

export function translateEnum(value: string, key: string, referenceEnum: any): string {
  const translationKey: string = getEnumTranslationKey(value, key, referenceEnum);
  return t(translationKey);
}

export function getEnumTranslationKey(value: string, key: string, referenceEnum: any): string {
  const enumKeys: string[] = Object.keys(referenceEnum);
  const enumValues: string[] = Object.values(referenceEnum);
  const index: number = enumValues.indexOf(value);

  if (index < 0) {
    if (process.env.NODE_ENV === 'development') {
      console.error('Not valid value in the provided Enum', value);
    }
    return undefined;
  }
  const enumKey: string = enumKeys[index].toLowerCase();

  return `${key}-${enumKey}`;
}
